import { styled } from '@mui/material';

export const ListItem = styled('li')`
  padding: 5px 0;
  font-weight: 700;
  list-style-type: disc;

  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

export const NewsSectionTitle = styled('div')`
  width: fit-content;

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    padding-left: 1rem;
    margin-bottom: 2rem;
    border-left: 5px solid ${(props) => props.theme.palette.secondary.main};
    font-size: 1.2rem;
    color: ${(props) => props.theme.palette.primary.main};
  }

  h2 {
    font-size: ${(props) => props.theme.typography.h2.fontSize};
    font-weight: bold;
  }

  span {
    font-size: ${(props) => props.theme.typography.h2.fontSize};
    font-weight: bold;
  }
`;

export const WordBorder = styled('div')`
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 2px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: ${(props) => props.theme.palette.secondary.main};
  height: 3px;
`;
